import * as activityManage from '../services/index';
export default {
  namespace: 'activityManage',
  state: {
    getActivityManageList: {},
  },
  effects: {
    *getActivityManageList({ payload: { values } }, { call, put }) {
      const response = yield call(activityManage.getActivityManageList, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          getActivityManageList: response,
        },
      });
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
